import type { ReactElement } from 'react'
import React from 'react'

import { mapLegacyIconToPhosphor } from '@nxt-insurance/constants'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import PhosphorIcon from '@ui-kit/components/PhosphorIcon'
import Icon from '@ui-kit/components/SvgIcon/index.web'

const SMALL_ICONS: { [name: string]: unknown } = IMAGE.icons.small

// The CMS returns an icon as a name (e.g. `bike_24`). Render it as a Phosphor icon
// when the name maps to one (matching the react-native app and flows-ui `Icon`),
// otherwise fall back to the legacy `@ui-kit` SVG asset. Renders nothing when there
// is no icon.
export const CmsIcon = ({
  name,
  size = 24,
}: {
  name: string | undefined
  size?: number
}): ReactElement | null => {
  const phosphorName = name ? mapLegacyIconToPhosphor(name) : undefined
  if (phosphorName) {
    return <PhosphorIcon name={phosphorName} size={size} />
  }

  const asset = name && SMALL_ICONS[name] ? SMALL_ICONS[name] : undefined
  return asset ? <Icon imgSrc={asset} /> : null
}
